import api from "apis/caseTimeLog";
import { PayPeriodViewModel } from "interfaces/Mueller.Business.Models";
import { Ref } from "react";
import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";

export const getPayPeriodList = (successCallback: (payPeriodList: PayPeriodViewModel[]) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getPayPeriodList(),
  successCallback,
  mountedRef,
});

export const submitFeedback = (payload, successCallback, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  payload: payload,
  endpoint: api.submitFeedback(),
  successCallback: successCallback,
  errorCallback: errorCallback,
  mountedRef: mountedRef,
});

export const getFeedback = (controlNumber: number, successCallback, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getFeedback(controlNumber),
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const getFeedbackCategories = (workTypeId, successCallback, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getFeedbackCategories(workTypeId),
  successCallback: successCallback,
  mountedRef: mountedRef,
});